import { render } from "./UnbilledCases.vue?vue&type=template&id=8fc248a4"
import script from "./UnbilledCases.vue?vue&type=script&lang=js"
export * from "./UnbilledCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/UnbilledCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fc248a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fc248a4', __exports__)) {
    console.log('reload')
    api.reload('8fc248a4', __exports__)
  }
  
  module.hot.accept("./UnbilledCases.vue?vue&type=template&id=8fc248a4", () => {
    console.log('re-render')
    api.rerender('8fc248a4', render)
  })

}


export default __exports__